import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import {
    EnableFinanceDeductibleResult,
    FinanceDeductible,
    FinanceDeductibleDetail,
    FinanceDeductibleImpact,
    FinanceDeductibleResponse,
    SaveFinanceDeductibleRequest,
} from "@features/admin/finance/deductible/types/financeDeductible";
import {
    createFinanceDeductible,
    deleteFinanceDeductible,
    disableFinanceDeductible,
    enableFinanceDeductible,
    fetchFinanceDeductible,
    fetchFinanceDeductibleImpact,
    fetchFinanceDeductibles,
    reorderFinanceDeductibles,
    updateFinanceDeductible,
} from "@features/admin/finance/deductible/api/financeDeductibleApi";

export const fetchFinanceDeductiblesAsync = async (
    nationId: number,
    params: Record<string, any>
): Promise<ApiResponse<FinanceDeductibleResponse | FinanceDeductible[]>> => {
    const { nationId: _removed, ...filteredParams } = params || {};
    return fetchFinanceDeductibles(nationId, filteredParams);
};

export const fetchAllFinanceDeductiblesAsync = async (nationId: number): Promise<FinanceDeductible[]> => {
    const response = await fetchFinanceDeductibles(nationId, { all: true });
    const data = response.getData();
    if (!data) return [];
    return Array.isArray(data) ? data : data.data ?? [];
};

export const fetchFinanceDeductibleAsync = (nationId: number, deductibleId: number): Promise<ApiResponse<FinanceDeductibleDetail>> =>
    fetchFinanceDeductible(nationId, deductibleId);

export const fetchFinanceDeductibleImpactAsync = (nationId: number, deductibleId: number): Promise<ApiResponse<FinanceDeductibleImpact>> =>
    fetchFinanceDeductibleImpact(nationId, deductibleId);

export const createFinanceDeductibleAsync = (nationId: number, data: SaveFinanceDeductibleRequest): Promise<ApiResponse<ApiMessageResponse>> =>
    createFinanceDeductible(nationId, data);

export const updateFinanceDeductibleAsync = (
    nationId: number,
    deductibleId: number,
    data: SaveFinanceDeductibleRequest
): Promise<ApiResponse<ApiMessageResponse>> => updateFinanceDeductible(nationId, deductibleId, data);

export const disableFinanceDeductibleAsync = (nationId: number, deductibleId: number): Promise<ApiResponse<ApiMessageResponse>> =>
    disableFinanceDeductible(nationId, deductibleId);

export const enableFinanceDeductibleAsync = (
    nationId: number,
    deductibleId: number,
    resolveConflicts: boolean
): Promise<ApiResponse<EnableFinanceDeductibleResult>> =>
    enableFinanceDeductible(nationId, deductibleId, { resolve_conflicts: resolveConflicts });

export const deleteFinanceDeductibleAsync = (nationId: number, deductibleId: number): Promise<ApiResponse<ApiMessageResponse>> =>
    deleteFinanceDeductible(nationId, deductibleId);

export const reorderFinanceDeductiblesAsync = (nationId: number, deductibleIds: number[]): Promise<ApiResponse<ApiMessageResponse>> =>
    reorderFinanceDeductibles(nationId, { deductible_ids: deductibleIds });
